module.exports = __webpack_public_path__ + "img/Microphone - White.296fd988.png";